import * as React from 'react';

const STEPS = [
  {
    icon: 'fa-shopping-basket',
    title: 'Armá el pedido',
    text: 'Elegís desde tu casa, del trabajo o donde estés. Fruta y verdura seleccionada cada mañana en el Mercado de Abasto.',
  },
  {
    icon: 'fa-map-marker',
    title: 'Poné su dirección',
    text: 'En tu cuenta podés guardar varias direcciones: la tuya y la de ellos. Elegís a cuál va cada pedido.',
  },
  {
    icon: 'fa-clock-o',
    title: 'Elegí el día y la franja',
    text: 'Entregamos de lunes por la tarde a sábados por la mañana, en tres franjas horarias. Saben cuándo suena el timbre.',
  },
];

export function HowItWorks() {
  return (
    <section className="sq-how">
      <style>{`
        .sq-how {
          padding: 72px 24px;
          background: #fff;
        }
        .sq-how-inner {
          max-width: 1040px;
          margin: 0 auto;
        }
        .sq-how h2 {
          font-size: 30px;
          font-weight: 800;
          color: #1a1a1a;
          text-align: center;
          margin: 0 0 12px;
        }
        .sq-how .sq-how-lead {
          font-size: 17px;
          color: #666;
          text-align: center;
          margin: 0 auto 48px;
          max-width: 620px;
          line-height: 1.6;
        }
        .sq-how-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 28px;
        }
        .sq-how-card {
          background: #fafaf7;
          border: 1px solid #eee;
          border-radius: 12px;
          padding: 28px 24px;
        }
        .sq-how-num {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #1EAA25;
          color: #fff;
          font-size: 18px;
          margin-bottom: 16px;
        }
        .sq-how-card h3 {
          font-size: 19px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 10px;
        }
        .sq-how-card p {
          font-size: 15px;
          color: #555;
          line-height: 1.65;
          margin: 0;
        }
        @media (max-width: 768px) {
          .sq-how { padding: 56px 20px; }
          .sq-how h2 { font-size: 25px; }
          .sq-how-grid { grid-template-columns: 1fr; gap: 20px; }
        }
      `}</style>

      <div className="sq-how-inner">
        <h2>Cómo funciona</h2>
        <p className="sq-how-lead">
          El pedido lo hacés vos. Ellos sólo abren la puerta.
        </p>
        <div className="sq-how-grid">
          {STEPS.map((step) => (
            <div className="sq-how-card" key={step.title}>
              <span className="sq-how-num"><i className={`fa ${step.icon}`} /></span>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
